/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_DescriptionInputs */

const fr_page_description = /** @type {(inputs: Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page de démo locale du widget. Configurez le token et les autres valeurs ci-dessous ; la configuration est persistée dans le`)
};

const en_page_description = /** @type {(inputs: Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local demo page for the widget. Configure the token and other values below; the configuration is persisted in`)
};

/**
* | output |
* | --- |
* | "Local demo page for the widget. Configure the token and other values below; the configuration is persisted in" |
*
* @param {Page_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_description = /** @type {((inputs?: Page_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_description(inputs)
	return en_page_description(inputs)
});